/**
 * useLocale - 화면 언어 결정 체인의 유일한 소유자.
 * 개인 설정 -> 회사 대표 언어 -> ko 순으로 정한다. 다른 곳에서 locale 을 판단하지 않는다.
 */
import { computed } from 'vue';
import { useLocaleStore } from '@/stores/locale';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, LOCALES } from '@/locales';

// 서버는 FRM_LOCALE 코드(KO·EN·ZH_CN), 프론트와 Accept-Language 는 BCP47(ko·en·zh-cn) 을 쓴다.
export function toLocaleCd(locale) {
  return String(locale || DEFAULT_LOCALE).toUpperCase().replace(/-/g, '_');
}

/** 서버 코드 -> 지원 언어. 미지원·공란이면 '' 를 돌려 체인의 다음 단계로 넘긴다. */
export function fromLocaleCd(localeCd) {
  const l = String(localeCd || '').toLowerCase().replace(/_/g, '-');
  return SUPPORTED_LOCALES.includes(l) ? l : '';
}

export function useLocale() {
  const store = useLocaleStore();

  return {
    current: computed(() => store.locale),
    supported: SUPPORTED_LOCALES,
    /** 선택기에 띄울 전체 목록(리소스 없는 것 포함). ready=false 면 아직 못 고른다. */
    options: LOCALES.map((l) => ({ ...l, ready: SUPPORTED_LOCALES.includes(l.cd) })),
    /** 확정 저장(화면 + 기기 캐시). 서버 저장은 호출부가 별도로 한다. */
    set: (locale) => store.setLocale(locale),
    /** 저장 전 미리보기. */
    preview: (locale) => store.previewLocale(locale),
    /** 개인 -> 회사 대표 -> ko. 부트스트랩(App.vue)에서만 호출한다. */
    resolve: (personalCd, companyMainCd) =>
      store.setLocale(fromLocaleCd(personalCd) || fromLocaleCd(companyMainCd) || DEFAULT_LOCALE),
  };
}
